export default function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".submitErrors") || empty;
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/getFormSubmitErrors.js
// module id = 2139
// module chunks = 1